import { useNavigate } from "react-router-dom";
import { ChevronRight, ShieldCheck, MapPin, Camera } from "lucide-react";
import { MobileFrame } from "../../components/MobileFrame";

const features = [
  {
    Icon: MapPin,
    title: "GPS Tracking Real-time",
    desc: "Pantau pergerakan tim sales setiap 30 detik secara akurat.",
  },
  {
    Icon: Camera,
    title: "Bukti Kunjungan",
    desc: "Foto otomatis ber-watermark GPS, waktu & salesman.",
  },
  {
    Icon: ShieldCheck,
    title: "Validasi Prospek",
    desc: "Prospek hanya valid jika berada di radius lokasi kunjungan.",
  },
];

export default function Splash() {
  const navigate = useNavigate();

  return (
    <MobileFrame>
      <div className="min-h-full flex flex-col bg-gradient-to-b from-honda-red via-honda-red to-[#9F140E] text-white">
        {/* Top brand area */}
        <div className="pt-14 px-6 pb-8">
          <div className="flex items-center gap-2">
            <div className="w-10 h-10 rounded-lg bg-white text-honda-red flex items-center justify-center font-extrabold text-xl font-heading">
              H
            </div>
            <div>
              <p className="text-[10px] tracking-[0.2em] uppercase opacity-80">Honda Babel</p>
              <p className="font-heading font-bold text-lg leading-none">SALES TRACK</p>
            </div>
          </div>

          <div className="mt-12 animate-slide-up">
            <h1 className="font-heading font-extrabold text-4xl leading-tight">
              Sales Coverage
              <br />
              Intelligence System
            </h1>
            <p className="mt-3 text-white/85 text-base max-w-sm leading-relaxed">
              Sistem canvasing & monitoring penjualan motor Honda
              wilayah Bangka Belitung.
            </p>
          </div>
        </div>

        {/* White panel */}
        <div className="flex-1 bg-white text-honda-ink rounded-t-[32px] -mt-2 px-6 pt-10 pb-8 flex flex-col">
          <div className="space-y-5">
            {features.map(({ Icon, title, desc }) => (
              <div key={title} className="flex gap-4 items-start">
                <div className="w-11 h-11 rounded-xl bg-honda-red-light text-honda-red flex items-center justify-center flex-shrink-0">
                  <Icon size={22} strokeWidth={2.2} />
                </div>
                <div className="flex-1">
                  <p className="font-heading font-semibold text-base text-honda-ink">{title}</p>
                  <p className="text-sm text-honda-muted mt-0.5 leading-snug">{desc}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-auto pt-10 space-y-3">
            <button
              data-testid="splash-get-started-button"
              onClick={() => navigate("/login")}
              className="w-full bg-honda-red text-white py-4 rounded-2xl font-heading font-semibold text-base flex items-center justify-center gap-2 hover:bg-honda-red-hover transition-colors shadow-lg shadow-honda-red/30"
            >
              Mulai Sekarang
              <ChevronRight size={18} />
            </button>
            <p className="text-center text-xs text-honda-subtle">
              v1.0.0 · Honda Babel © 2026
            </p>
          </div>
        </div>
      </div>
    </MobileFrame>
  );
}
